import { render } from "./LoginModal.vue?vue&type=template&id=3b15ccd8&scoped=true"
import script from "./LoginModal.vue?vue&type=script&lang=js"
export * from "./LoginModal.vue?vue&type=script&lang=js"

import "./LoginModal.vue?vue&type=style&index=0&id=3b15ccd8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b15ccd8"]])

export default __exports__